import { Box } from "@mui/material";
import { linear_content_style } from "../linear-layout/LinearLayout";
import Markdown from "../markdown/Markdown";
import MarkdownBlock from "../markdown/MarkdownBlock";

const FrmDemo_BlankNote = () => {
  return (
    <div style={linear_content_style}>
      {md_Headline()}
      <br />
      {md_TODO()}

      {md_Title1()}
      {md_Block1()}
      {md_Block2()}

      {md_Title2()}
      {md_Block1()}
      {md_Block2()}
      {md_Block3()}
      <br />
      <br />
    </div>
  )

  function md_TODO() {
    return (<><MarkdownBlock title="TODO" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### TODO
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Headline() {
    return <Markdown>{`

主題名稱
=========
\`FrmDemo_BlankNote\`  
- AAA  
- BBB  
- [CCC](#block3)  
`}
    </Markdown>
  }

  function md_Title1() {
    return <Markdown>{'\n\n標題1\n---'}</Markdown>
  }

  function md_Block1() {
    return (<><MarkdownBlock title="區塊1" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### 區塊1
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Block2() {
    return (<><MarkdownBlock title="區塊2" defaultExpanded={true}>
      <Markdown anchor_id="" className="px-0">{`
### 區塊2
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Block3() {
    return (<><MarkdownBlock title="區塊3">
      <Markdown anchor_id="block3" className="px-0">{`
### 區塊3
- AAA
- BBB
- CCC
`}
      </Markdown>
      <Box></Box>
    </MarkdownBlock></>);
  }

  function md_Title2() {
    return <Markdown>{'\n\n標題2\n---'}</Markdown>
  }

}


export default FrmDemo_BlankNote